// extracted by mini-css-extract-plugin
export default {"logo":"logo_logo__5jWXb","logo__text":"logo_logo__text__HBuDQ"};